class ExtendableError extends Error {
  constructor(message) {
    super(message);
    this.name = this.constructor.name;
    if (typeof Error.captureStackTrace === 'function') {
      Error.captureStackTrace(this, this.constructor);
    } else {
      this.stack = new Error(message).stack;
    }
  }
}

export class GraphQLError extends ExtendableError {}
export class NetworkError extends ExtendableError {}

export class ConfigAPIError extends ExtendableError {}
export class ConfigAPI4xx extends ExtendableError {}
export class ConfigAPI5xx extends ExtendableError {}
export class ConfigAPITimeout extends ExtendableError {}
export class HomeAPIError extends ExtendableError {}
export class HomeAPI4xx extends ExtendableError {}
export class HomeAPI5xx extends ExtendableError {}
export class HomeAPITimeout extends ExtendableError {}
export class HomeAPIQueryError extends ExtendableError {}
export class OrderHistoryAPIError extends ExtendableError {}
export class OrderHistoryAPI4xx extends ExtendableError {}
export class OrderHistoryAPI5xx extends ExtendableError {}
export class OrderHistoryAPITimeout extends ExtendableError {}
export class OrderReceiptAPIError extends ExtendableError {}
export class OrderReceiptAPI4xx extends ExtendableError {}
export class OrderReceiptAPI5xx extends ExtendableError {}
export class OrderReceiptAPITimeout extends ExtendableError {}
export class OrderHelpAPIError extends ExtendableError {}
export class OrderHelpAPI4xx extends ExtendableError {}
export class OrderHelpAPI5xx extends ExtendableError {}
export class OrderHelpAPITimeout extends ExtendableError {}
export class OrderStatusAPIError extends ExtendableError {}
export class OrderStatusAPI4xx extends ExtendableError {}
export class ReferralAPIError extends ExtendableError {}
export class ReferralAPI4xx extends ExtendableError {}
export class ReferralAPI5xx extends ExtendableError {}
export class ReferralAPITimeout extends ExtendableError {}
export class LandingPagesAPIError extends ExtendableError {}
export class LandingPageDynamicImportError extends ExtendableError {}
export class StoryblokAPI4xx extends ExtendableError {}
export class StoryblokAPI5xx extends ExtendableError {}
export class BrandPagesAPI4xx extends ExtendableError {}

export const errorForConfig = (config) => {
  let error;
  if (config.error) {
    const configStatus = config.error.status;
    const message = config.error.message || '';

    // config error means config failed, no auth for user, hard fail.
    if (Math.floor(configStatus / 100) === 4) {
      error = new ConfigAPI4xx(`API Error: Config (${configStatus}) ${message}`);
    } else if (configStatus === 504) {
      error = new ConfigAPITimeout(`API Error: Config (${configStatus}) ${message}`);
    } else if (Math.floor(configStatus / 100) === 5) {
      error = new ConfigAPI5xx(`API Error: Config (${configStatus}) ${message}`);
    } else {
      error = new ConfigAPIError(`API Error: Config (${configStatus}) ${message}`);
    }
  }
  return error;
};
